// extracted by mini-css-extract-plugin
module.exports = {"headerInfo":"styles_headerInfo__3vWI0","client":"styles_client__3zJHw"};